import { ReadonlyRepositoryListService, Result } from '@softline/core';
import { computed, inject, Injectable } from '@angular/core';
import { LieferantenQuery } from '../types/lieferanten-query';
import { SupplierDiscount } from '../types/supplier-discount';
import { LieferantenRabattRepository } from '../repositories/lieferanten-rabatt.repository';
import { SupplierIdService } from './supplier-id.service';

@Injectable()
export class LieferantenRabattService extends ReadonlyRepositoryListService<
  SupplierDiscount,
  Result<SupplierDiscount[]>,
  LieferantenQuery
> {
  readonly #supplierIdService = inject(SupplierIdService);

  supplierId = computed(() => this.#supplierIdService.supplierId()());
  override params = computed(() => {
    return { id: this.supplierId() };
  });

  constructor() {
    super(inject(LieferantenRabattRepository));
  }

  protected override getItems(
    result: Result<SupplierDiscount[]> | null | undefined
  ): SupplierDiscount[] {
    return result as any;
  }
}
